import { Collapse } from "antd";
import "../../../app/styles/components/common/style.css";

function CollapseBar({
  onChange,
  defaultActiveKey,
  expandIconPosition = "end",
  items,
  activeKey,
  className,
  expandIcon,
  style = {},
  ...props
}) {
  return (
    <>
      <Collapse
        {...props}
        customItemClass=""
        style={style}
        className={`${className} custom-collapse `}
        defaultActiveKey={defaultActiveKey}
        onChange={onChange}
        expandIconPosition={expandIconPosition}
        items={items}
        ghost
        activeKey={activeKey}
        expandIcon={expandIcon}
      />
    </>
  );
}

export default CollapseBar;
